import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios, { post, get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../../config";
import empty from "is-empty";
import Breadcrumbs from "../../Helper/Breadcrumbs";
import Select from "react-select";
import { Stepper, Step, StepLabel, StepButton } from "@mui/material";
import { FaCamera, FaPlus, FaTimes } from "react-icons/fa";

const ensureUrlProtocol = (url) => {
    if (!url) return "";
    let cleanUrl = url.trim();
    if (!/^https?:\/\//i.test(cleanUrl)) {
        return `https://${cleanUrl}`;
    }
    return cleanUrl;
};

const EventVendorForm = (props) => {
    let history = useHistory();
    let tokenKey = {
        Authorization: "Token " + sessionStorage.getItem("tokenKey"),
    };
    let propsState = props.history.location.state;
    const [form, setForm] = useState({
        // Initial form state mapping to user request structure
        step_1_category: { vendor_category: "" },
        step_2_business: {
            business_name: "", business_type: "", contact_person: "",
            mobile_number: "", email: "", website_url: "", established_year: "",
            pan_number: "", gstin: ""
        },
        step_3_bank: { account_holder: "", account_number: "", ifsc_code: "", bank_name: "" },
        step_4_location: {
            primary_city: null, primary_area: null, operating_cities: [], service_radius: "",
            destination_wedding: "", address: "", pincode: ""
        },
        step_5_service: {
            service_title: "", service_description: "", starting_price: "",
            pricing_model: "", package_details: { gold: "", platinum: "" }
        },
        step_6_media: {
            cover_image: "", portfolio_images: [], instagram_url: "",
            facebook_url: "", youtube_url: "", languages: []
        },
        step_7_operations: {
            response_time: "", availability: "", gmb_url: "",
            terms_accepted: false
        },
        step_8_operations: {
            photographer_count: "", video_services: false, photography_styles: [],
            album_quality: "", drone_photography: false, raw_files_provided: false,
            edit_turnaround_time: "", special_packages: ""
        }
    });

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [allAreaOptions, setAllAreaOptions] = useState([]);
    const [filteredAreaOptions, setFilteredAreaOptions] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const steps = [
        "Category", "Business", "Bank", "Location", "Service", "Media", "Operations", "Details"
    ];

    const [editMode, setEditMode] = useState(
        (propsState && propsState.editMode) || false
    );
    const [loading, setLoading] = useState(true);

    let breadcrumbData = [
        { title: "Event Vendor", href: "/eventVendorList" },
        { title: editMode ? "View" : "Create", href: "#" }
    ];

    let toastAttr = {
        theme: "colored", position: "top-center", autoClose: 1000,
        hideProgressBar: true, closeOnClick: true, pauseOnHover: true,
        draggable: true, progress: undefined,
    };

    const handleInput = (section, key, value) => {
        setForm(prevForm => ({
            ...prevForm,
            [section]: {
                ...prevForm[section],
                [key]: value
            }
        }));
    };

    const handlePortfolioImageChange = (index, value) => {
        const newImages = [...form.step_6_media.portfolio_images];
        newImages[index] = value;
        handleInput("step_6_media", "portfolio_images", newImages);
    };

    const addPortfolioImage = () => {
        handleInput("step_6_media", "portfolio_images", [...form.step_6_media.portfolio_images, ""]);
    };

    const removePortfolioImage = (index) => {
        const newImages = form.step_6_media.portfolio_images.filter((_, i) => i !== index);
        handleInput("step_6_media", "portfolio_images", newImages);
    };

    const handleFileUpload = (e, section, key, index = null) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        post(config.service + "/v2/event-vendors/media/upload/", formData, {
            headers: {
                ...tokenKey,
                "Content-Type": "multipart/form-data",
            },
        })
            .then((res) => {
                setLoading(false);
                if (res.data && res.data.url) {
                    if (index !== null) {
                        const newArray = [...form[section][key]];
                        newArray[index] = res.data.url;
                        handleInput(section, key, newArray);
                    } else {
                        handleInput(section, key, res.data.url);
                    }
                    toast.success("File uploaded successfully", toastAttr);
                } else {
                    toast.error("Upload failed: No URL returned", toastAttr);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Upload error:", err);
                toast.error("File upload failed", toastAttr);
            });
    };

    const handleMultipleFileUpload = (e, section, key) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        setLoading(true);
        const uploadPromises = files.map(file => {
            const formData = new FormData();
            formData.append("file", file);
            return post(config.service + "/v2/event-vendors/media/upload/", formData, {
                headers: {
                    ...tokenKey,
                    "Content-Type": "multipart/form-data",
                },
            });
        });

        Promise.all(uploadPromises)
            .then((results) => {
                setLoading(false);
                const urls = results.map(res => res.data.url).filter(url => !!url);
                if (urls.length > 0) {
                    handleInput(section, key, [...form[section][key], ...urls]);
                    toast.success(`${urls.length} files uploaded successfully`, toastAttr);
                } else {
                    toast.error("Bulk upload failed: No URLs returned", toastAttr);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Bulk upload error:", err);
                toast.error("One or more files failed to upload", toastAttr);
            });
    };

    const validateStep = (step) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        switch (step) {
            case 0:
                if (empty(form.step_1_category.vendor_category)) {
                    toast.error("Vendor Category is required", toastAttr);
                    return false;
                }
                break;
            case 1:
                const biz = form.step_2_business;
                if (empty(biz.business_name)) {
                    toast.error("Business Name is required", toastAttr);
                    return false;
                }
                if (empty(biz.business_type)) {
                    toast.error("Business Type is required", toastAttr);
                    return false;
                }
                if (empty(biz.contact_person)) {
                    toast.error("Contact Person Name is required", toastAttr);
                    return false;
                }
                if (empty(biz.mobile_number)) {
                    toast.error("Mobile Number is required", toastAttr);
                    return false;
                }
                if (!phoneRegex.test(biz.mobile_number)) {
                    toast.error("Please enter a valid 10-digit mobile number", toastAttr);
                    return false;
                }
                if (biz.email && !emailRegex.test(biz.email)) {
                    toast.error("Please enter a valid email address", toastAttr);
                    return false;
                }
                if (biz.established_year && (biz.established_year < 1900 || biz.established_year > new Date().getFullYear())) {
                    toast.error("Please enter a valid established year (YYYY)", toastAttr);
                    return false;
                }
                break;
            case 2:
                // Step 3 Bank Details: Optional
                break;
            case 3:
                const loc = form.step_4_location;
                if (!loc.primary_city) {
                    toast.error("Primary City is required", toastAttr);
                    return false;
                }
                if (empty(loc.address)) {
                    toast.error("Address is required", toastAttr);
                    return false;
                }
                break;
            case 4:
                const srv = form.step_5_service;
                if (empty(srv.service_title)) {
                    toast.error("Service Title is required", toastAttr);
                    return false;
                }
                if (empty(srv.starting_price)) {
                    toast.error("Starting Price is required", toastAttr);
                    return false;
                }
                if (srv.starting_price < 0) {
                    toast.error("Starting Price cannot be negative", toastAttr);
                    return false;
                }
                if (empty(srv.service_description)) {
                    toast.error("Service Description is required", toastAttr);
                    return false;
                }
                if (srv.service_description.length < 50) {
                    toast.error("Service Description must be at least 50 characters", toastAttr);
                    return false;
                }
                break;
            case 5:
                const media = form.step_6_media;
                if (empty(media.cover_image)) {
                    toast.error("Cover Image is required", toastAttr);
                    return false;
                }
                const validImages = media.portfolio_images.filter(img => !empty(img));
                if (validImages.length < 5) {
                    toast.error(`Minimum 5 portfolio images required (currently ${validImages.length})`, toastAttr);
                    return false;
                }
                break;
            case 6:
                const ops = form.step_7_operations;
                if (empty(ops.response_time)) {
                    toast.error("Expected Response Time is required", toastAttr);
                    return false;
                }
                break;
            default:
                break;
        }
        return true;
    };

    const handleNext = () => {
        if (validateStep(activeStep)) {
            setActiveStep((prev) => prev + 1);
        }
    };
    const handleBack = () => setActiveStep((prev) => prev - 1);

    const saveForm = () => {
        // Validate all steps before submission
        for (let i = 0; i < steps.length; i++) {
            if (!validateStep(i)) {
                setActiveStep(i);
                return;
            }
        }

        setLoading(true);

        // Transform form state to match the exact JSON structure requested
        let payload = {
            category: form.step_1_category.vendor_category,

            business_name: form.step_2_business.business_name,
            business_type: form.step_2_business.business_type,
            contact_person: form.step_2_business.contact_person,
            email: form.step_2_business.email,
            website_url: ensureUrlProtocol(form.step_2_business.website_url),
            established_year: parseInt(form.step_2_business.established_year) || 0,
            pan_number: form.step_2_business.pan_number,
            gstin: form.step_2_business.gstin,
            phone_number: form.step_2_business.mobile_number,
            account_holder: form.step_3_bank.account_holder,
            account_number: form.step_3_bank.account_number,
            ifsc_code: form.step_3_bank.ifsc_code,
            bank_name: form.step_3_bank.bank_name,

            primary_city_name: form.step_4_location.primary_city ? form.step_4_location.primary_city.label : "",
            primary_city: form.step_4_location.primary_city ? form.step_4_location.primary_city.value : null,
            primary_area_name: form.step_4_location.primary_area ? form.step_4_location.primary_area.label : "",
            primary_area: form.step_4_location.primary_area ? form.step_4_location.primary_area.value : null,
            operating_cities: form.step_4_location.operating_cities.map(c => c.value || c),
            service_radius: form.step_4_location.service_radius,
            destination_wedding: form.step_4_location.destination_wedding,
            address: form.step_4_location.address,
            pincode: form.step_4_location.pincode,

            service_title: form.step_5_service.service_title,
            service_description: form.step_5_service.service_description,
            starting_price: parseFloat(form.step_5_service.starting_price) || 0,
            pricing_model: form.step_5_service.pricing_model,
            package_details: form.step_5_service.package_details,

            cover_image: ensureUrlProtocol(form.step_6_media.cover_image),
            portfolio_images: form.step_6_media.portfolio_images.map(url => ensureUrlProtocol(url)),
            instagram_url: ensureUrlProtocol(form.step_6_media.instagram_url),
            facebook_url: ensureUrlProtocol(form.step_6_media.facebook_url),
            youtube_url: ensureUrlProtocol(form.step_6_media.youtube_url),
            languages: form.step_6_media.languages.map(l => l.value || l),

            response_time: form.step_7_operations.response_time,
            availability: form.step_7_operations.availability,
            gmb_url: ensureUrlProtocol(form.step_7_operations.gmb_url),

            form_data: {
                // Mapping step 8 operations to the form_data object in JSON
                photography_styles: form.step_8_operations.photography_styles.map(s => s.value || s),
                video_services: form.step_8_operations.video_services,
                album_quality: form.step_8_operations.album_quality,
                drone_photography: form.step_8_operations.drone_photography,
                number_of_photographers: parseInt(form.step_8_operations.photographer_count) || 0,
                raw_files_provided: form.step_8_operations.raw_files_provided,
                edit_turnaround_time: parseInt(form.step_8_operations.edit_turnaround_time) || 0,
                special_packages: form.step_8_operations.special_packages
            },

            terms_accepted: form.step_7_operations.terms_accepted
        };

        console.log("Form Data Submitted:", payload);

        let url = editMode
            // ? config.service + "/masters/event_vendor/" + propsState.id + "/"
            // : config.service + "/masters/event_vendor/create/";
            ? "http://127.0.0.1:8000/api/v2/event-vendors/create/" + propsState.id + "/"
            : config.service + "/v2/event-vendors/agent/create/";
        let method = editMode ? "patch" : "post";

        axios({
            url: url,
            method: method,
            headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
            data: payload
        }).then(res => {
            setLoading(false);
            toast.success("Saved successfully", toastAttr);
            setTimeout(() => history.push('/eventVendorList'), 1000);
        }).catch(err => {
            setLoading(false);
            // console.log(err.response.data);
            toast.error(err.response.data, toastAttr);
        })
    }

    useEffect(() => {
        // Fetch categories dynamically
        get(config.service + "/v2/event-vendors/meta/categories/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
            .then(res => {
                if (res.data) {
                    setCategoryOptions(res.data);
                }
            }).catch(err => {
                console.error("Failed to fetch categories", err);
            });

        // Fetch cities
        get(config.service + "/masters/city/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
            .then(res => {
                if (res.data) {
                    setCityOptions(res.data.map(c => ({ value: c.id, label: c.name })));
                }
            }).catch(err => console.error("Failed to fetch cities", err));

        // Fetch areas
        get(config.service + "/masters/area/list/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
            .then(res => {
                if (res.data) {
                    const areas = res.data.map(a => ({
                        value: a.id,
                        label: a.name,
                        city_id: a.city_id,
                        pincode: a.pincode
                    }));
                    setAllAreaOptions(areas);
                }
            }).catch(err => console.error("Failed to fetch areas", err));

        if (editMode && propsState.id) {
            setLoading(true);
            get("http://127.0.0.1:8000/api/v2/event-vendors/submit/" + propsState.id + "/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
                .then(res => {
                    // Assuming API returns data in same structure, or map it here
                    setForm(res.data);
                    setLoading(false);
                }).catch(err => {
                    setLoading(false);
                    toast.error("Failed to fetch details", toastAttr);
                })
        } else {
            setLoading(false);
        }
    }, []);

    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Vendor Category <span className="text-danger">*</span></Form.Label>
                                <Form.Control as="select" style={{ fontSize: '14px' }} value={form.step_1_category.vendor_category} onChange={(e) => {
                                    const value = e.target.value;
                                    const isPhotography = value.toLowerCase() === 'photography';
                                    setForm(prevForm => ({
                                        ...prevForm,
                                        step_1_category: {
                                            ...prevForm.step_1_category,
                                            vendor_category: value
                                        },
                                        ...(isPhotography ? {
                                            step_8_operations: {
                                                ...prevForm.step_8_operations,
                                                drone_photography: true,
                                                video_services: true,
                                                raw_files_provided: true
                                            }
                                        } : {})
                                    }));
                                }}>
                                    <option value="">Select</option>
                                    {categoryOptions && categoryOptions.map((cat, index) => (
                                        <option key={index} value={cat.slug || cat.id || cat.name}>{cat.name || cat.slug || cat}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                );
            case 1:
                return (
                    <Row>
                        <Col md={6}><Form.Group><Form.Label>Business Name <span className="text-danger">*</span></Form.Label><Form.Control type="text" value={form.step_2_business.business_name} onChange={e => handleInput("step_2_business", "business_name", e.target.value)} /></Form.Group></Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Business Type <span className="text-danger">*</span></Form.Label>
                                <Form.Control as="select" className="form-control" style={{ fontSize: '12px' }} value={form.step_2_business.business_type} onChange={e => handleInput("step_2_business", "business_type", e.target.value)}>
                                    <option value="">Select</option>
                                    <option value="Individual">Individual</option>
                                    <option value="Partnership">Partnership</option>
                                    <option value="Company">Company</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}><Form.Group><Form.Label>Contact Person <span className="text-danger">*</span></Form.Label><Form.Control type="text" value={form.step_2_business.contact_person} onChange={e => handleInput("step_2_business", "contact_person", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Mobile Number <span className="text-danger">*</span></Form.Label><Form.Control type="tel" value={form.step_2_business.mobile_number} onChange={e => handleInput("step_2_business", "mobile_number", e.target.value.replace(/\D/g, ''))} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Email</Form.Label><Form.Control type="email" value={form.step_2_business.email} onChange={e => handleInput("step_2_business", "email", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Website URL</Form.Label><Form.Control type="text" value={form.step_2_business.website_url} onChange={e => handleInput("step_2_business", "website_url", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Year Established</Form.Label><Form.Control type="number" min="1900" value={form.step_2_business.established_year} onChange={e => handleInput("step_2_business", "established_year", Math.max(0, parseInt(e.target.value) || ""))} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>PAN Number</Form.Label><Form.Control type="text" value={form.step_2_business.pan_number} onChange={e => handleInput("step_2_business", "pan_number", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>GSTIN</Form.Label><Form.Control type="text" value={form.step_2_business.gstin} onChange={e => handleInput("step_2_business", "gstin", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 2:
                return (
                    <Row>
                        <Col md={6}><Form.Group><Form.Label>Account Holder Name</Form.Label><Form.Control type="text" value={form.step_3_bank.account_holder} onChange={e => handleInput("step_3_bank", "account_holder", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Account Number</Form.Label><Form.Control type="number" value={form.step_3_bank.account_number} onChange={e => handleInput("step_3_bank", "account_number", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>IFSC Code</Form.Label><Form.Control type="text" value={form.step_3_bank.ifsc_code} onChange={e => handleInput("step_3_bank", "ifsc_code", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Bank Name</Form.Label><Form.Control type="text" value={form.step_3_bank.bank_name} onChange={e => handleInput("step_3_bank", "bank_name", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 3:
                return (
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Primary City <span className="text-danger">*</span></Form.Label>
                                <Select
                                    placeholder="Select City"
                                    options={cityOptions}
                                    value={form.step_4_location.primary_city}
                                    onChange={(selected) => {
                                        handleInput("step_4_location", "primary_city", selected);
                                        handleInput("step_4_location", "primary_area", null);
                                        if (selected) {
                                            const filtered = allAreaOptions.filter(a => a.city_id === selected.value);
                                            setFilteredAreaOptions(filtered);
                                        } else {
                                            setFilteredAreaOptions([]);
                                        }
                                    }}
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Primary Area</Form.Label>
                                <Select
                                    placeholder="Select Area"
                                    options={filteredAreaOptions}
                                    value={form.step_4_location.primary_area}
                                    onChange={(selected) => {
                                        handleInput("step_4_location", "primary_area", selected);
                                        if (selected && selected.pincode) {
                                            handleInput("step_4_location", "pincode", selected.pincode);
                                        }
                                    }}
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Operating Cities</Form.Label>
                                <Select
                                    isMulti
                                    placeholder="Select Cities"
                                    options={cityOptions}
                                    value={form.step_4_location.operating_cities}
                                    onChange={(selected) => handleInput("step_4_location", "operating_cities", selected)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}><Form.Group><Form.Label>Service Radius</Form.Label><Form.Control type="text" value={form.step_4_location.service_radius} onChange={e => handleInput("step_4_location", "service_radius", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Destination Wedding</Form.Label><Form.Control type="text" value={form.step_4_location.destination_wedding} onChange={e => handleInput("step_4_location", "destination_wedding", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Pincode</Form.Label><Form.Control type="text" value={form.step_4_location.pincode} onChange={e => handleInput("step_4_location", "pincode", e.target.value)} /></Form.Group></Col>
                        <Col md={12}><Form.Group><Form.Label>Address <span className="text-danger">*</span></Form.Label><Form.Control as="textarea" rows={3} value={form.step_4_location.address} onChange={e => handleInput("step_4_location", "address", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 4:
                return (
                    <Row>
                        <Col md={6} className="mt-4"><Form.Group><Form.Label>Service Title <span className="text-danger">*</span></Form.Label><Form.Control type="text" value={form.step_5_service.service_title} onChange={e => handleInput("step_5_service", "service_title", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Starting Price <span className="text-danger">*</span></Form.Label><Form.Control type="number" min="0" value={form.step_5_service.starting_price} onChange={e => {
                            const val = parseFloat(e.target.value);
                            handleInput("step_5_service", "starting_price", isNaN(val) ? "" : Math.max(0, val));
                        }} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Pricing Model</Form.Label><Form.Control type="text" value={form.step_5_service.pricing_model} onChange={e => handleInput("step_5_service", "pricing_model", e.target.value)} /></Form.Group></Col>
                        <Col md={12}><Form.Group><Form.Label>Service Description <span className="text-danger">*</span></Form.Label><Form.Control as="textarea" rows={3} value={form.step_5_service.service_description} onChange={e => handleInput("step_5_service", "service_description", e.target.value)} /></Form.Group></Col>
                        {/* Package Details JSON Editor / Simplified Inputs */}
                        <Col md={6}><Form.Group><Form.Label>Gold Package Price</Form.Label><Form.Control type="text" value={form.step_5_service.package_details.gold} onChange={e => handleInput("step_5_service", "package_details", { ...form.step_5_service.package_details, gold: e.target.value })} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Platinum Package Price</Form.Label><Form.Control type="text" value={form.step_5_service.package_details.platinum} onChange={e => handleInput("step_5_service", "package_details", { ...form.step_5_service.package_details, platinum: e.target.value })} /></Form.Group></Col>
                    </Row>
                );
            case 5:
                return (
                    <Row>
                        <Col md={12}>
                            <Form.Label>Cover Image <span className="text-danger">*</span></Form.Label>
                            <div className="d-flex align-items-center mb-4">
                                <label className="m-0 p-0" style={{ cursor: "pointer" }}>
                                    <div className="border rounded d-flex align-items-center justify-content-center bg-light" style={{ width: "120px", height: "120px", overflow: "hidden", position: "relative" }}>
                                        {form.step_6_media.cover_image ? (
                                            <>
                                                <img
                                                    src={form.step_6_media.cover_image}
                                                    alt="Cover"
                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute" style={{ bottom: "5px", right: "5px", background: "rgba(0,0,0,0.5)", borderRadius: "50%", padding: "5px" }}>
                                                    <FaCamera color="#fff" size={14} />
                                                </div>
                                            </>
                                        ) : (
                                            <div className="text-center text-muted">
                                                <FaCamera size={30} className="mb-1" />
                                                <div className="small">Add Cover</div>
                                            </div>
                                        )}
                                        <Form.Control
                                            type="file"
                                            onChange={(e) => handleFileUpload(e, "step_6_media", "cover_image")}
                                            accept="image/*"
                                            style={{ display: "none" }}
                                        />
                                    </div>
                                </label>
                                {form.step_6_media.cover_image && (
                                    <div className="ml-3 small text-muted text-break" style={{ maxWidth: "300px" }}>
                                        URL: {form.step_6_media.cover_image}
                                    </div>
                                )}
                            </div>
                        </Col>

                        <Col md={12} className="mt-3">
                            <Form.Label>Portfolio Images <span className="text-danger">*</span> (Min 5)</Form.Label>
                            <div className="d-flex flex-wrap">
                                {form.step_6_media.portfolio_images.map((url, index) => (
                                    <div key={index} className="mr-3 mb-3 position-relative border rounded" style={{ width: "100px", height: "100px", background: "#f8f9fa" }}>
                                        {url ? (
                                            <>
                                                <img
                                                    src={url}
                                                    alt={`Portfolio ${index + 1}`}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "4px" }}
                                                />
                                                <div
                                                    className="position-absolute"
                                                    style={{ top: "-8px", right: "-8px", background: "#f03e3e", color: "#fff", borderRadius: "50%", width: "20px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: "12px" }}
                                                    onClick={() => removePortfolioImage(index)}
                                                >
                                                    <FaTimes />
                                                </div>
                                            </>
                                        ) : (
                                            <label className="m-0 p-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ cursor: "pointer" }}>
                                                <div className="text-center text-muted">
                                                    <FaPlus />
                                                </div>
                                                <Form.Control
                                                    type="file"
                                                    onChange={(e) => handleFileUpload(e, "step_6_media", "portfolio_images", index)}
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                />
                                            </label>
                                        )}
                                    </div>
                                ))}

                                <label className="mb-3 d-flex align-items-center justify-content-center border rounded bg-light" style={{ width: "100px", height: "100px", cursor: "pointer", borderStyle: "dashed !important" }}>
                                    <div className="text-center text-primary">
                                        <FaCamera size={24} />
                                        <div className="small font-weight-bold">+ Bulk</div>
                                    </div>
                                    <Form.Control
                                        type="file"
                                        multiple
                                        onChange={(e) => handleMultipleFileUpload(e, "step_6_media", "portfolio_images")}
                                        accept="image/*"
                                        style={{ display: "none" }}
                                    />
                                </label>
                            </div>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Instagram URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://..."
                                    value={form.step_6_media.instagram_url}
                                    onChange={e => handleInput("step_6_media", "instagram_url", e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Facebook URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://..."
                                    value={form.step_6_media.facebook_url}
                                    onChange={e => handleInput("step_6_media", "facebook_url", e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>YouTube URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://..."
                                    value={form.step_6_media.youtube_url}
                                    onChange={e => handleInput("step_6_media", "youtube_url", e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Languages Supported</Form.Label>
                                <Select
                                    isMulti
                                    options={[
                                        { value: "English", label: "English" },
                                        { value: "Hindi", label: "Hindi" },
                                        { value: "Kannada", label: "Kannada" },
                                        { value: "Tamil", label: "Tamil" },
                                        { value: "Telugu", label: "Telugu" }
                                    ]}
                                    value={form.step_6_media.languages.map(l => typeof l === 'string' ? { value: l, label: l } : l)}
                                    onChange={(selected) => handleInput("step_6_media", "languages", selected)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                );
            case 6:
                return (
                    <Row>
                        <Col md={6}><Form.Group><Form.Label>Response Time <span className="text-danger">*</span></Form.Label><Form.Control type="text" value={form.step_7_operations.response_time} onChange={e => handleInput("step_7_operations", "response_time", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>GMB URL</Form.Label><Form.Control type="text" value={form.step_7_operations.gmb_url} onChange={e => handleInput("step_7_operations", "gmb_url", e.target.value)} /></Form.Group></Col>
                        <Col md={6}><Form.Group><Form.Label>Availability</Form.Label><Form.Control type="text" value={form.step_7_operations.availability} onChange={e => handleInput("step_7_operations", "availability", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 7:
                if (form.step_1_category.vendor_category === 'photography' || form.step_1_category.vendor_category === 'Photography') {
                    return (
                        <Row>
                            <Col md={6}><Form.Group><Form.Label>Number of Photographers</Form.Label><Form.Control type="number" min="0" value={form.step_8_operations.photographer_count} onChange={e => handleInput("step_8_operations", "photographer_count", Math.max(0, parseInt(e.target.value) || ""))} /></Form.Group></Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Photography Styles</Form.Label>
                                    <Select
                                        isMulti
                                        options={[{ value: "Candid", label: "Candid" }, { value: "Cinematic", label: "Cinematic" }]}
                                        onChange={(selected) => handleInput("step_8_operations", "photography_styles", selected)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}><Form.Group><Form.Label>Edit Turnaround Time (days)</Form.Label><Form.Control type="number" min="0" value={form.step_8_operations.edit_turnaround_time} onChange={e => handleInput("step_8_operations", "edit_turnaround_time", Math.max(0, parseInt(e.target.value) || ""))} /></Form.Group></Col>
                            <Col md={6}><Form.Group><Form.Label>Album Quality</Form.Label><Form.Control type="text" value={form.step_8_operations.album_quality} onChange={e => handleInput("step_8_operations", "album_quality", e.target.value)} /></Form.Group></Col>
                            <Col md={6}><Form.Group><Form.Label>Special Packages</Form.Label><Form.Control type="text" value={form.step_8_operations.special_packages} onChange={e => handleInput("step_8_operations", "special_packages", e.target.value)} /></Form.Group></Col>
                            <Col md={2} className="d-flex align-items-center mt-3"><Form.Group className="m-0"><Form.Check type="checkbox" label="Video Services Provided" checked={form.step_8_operations.video_services} onChange={e => handleInput("step_8_operations", "video_services", e.target.checked)} /></Form.Group></Col>
                            <Col md={2} className="d-flex align-items-center mt-3"><Form.Group className="m-0"><Form.Check type="checkbox" label="Drone Photography" checked={form.step_8_operations.drone_photography} onChange={e => handleInput("step_8_operations", "drone_photography", e.target.checked)} /></Form.Group></Col>
                            <Col md={2} className="d-flex align-items-center mt-3"><Form.Group className="m-0"><Form.Check type="checkbox" label="Raw Files Provided" checked={form.step_8_operations.raw_files_provided} onChange={e => handleInput("step_8_operations", "raw_files_provided", e.target.checked)} /></Form.Group></Col>
                        </Row>
                    );
                } else {
                    return (
                        <Row>
                            <Col md={12}>
                                <div className="text-center p-5">
                                    <h4 className="text-muted">Specific details for {form.step_1_category.vendor_category || 'this category'} are not configured yet.</h4>
                                </div>
                            </Col>
                        </Row>
                    );
                }
            default:
                return "Unknown step";
        }
    };

    return (
        <Container className="vendor">
            <Row>
                <Col md={12} className="contBody">
                    <Card>
                        <CardBody className="theme-light">
                            <div className="card__title pageNav">
                                <Breadcrumbs data={breadcrumbData} />
                            </div>

                            <Stepper activeStep={activeStep} alternativeLabel nonLinear>
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepButton color="inherit" onClick={(e) => {
                                            e.preventDefault();
                                            if (index <= activeStep) {
                                                setActiveStep(index);
                                            } else {
                                                // Prevent jumping forward without validation
                                                for (let i = activeStep; i < index; i++) {
                                                    if (!validateStep(i)) {
                                                        setActiveStep(i);
                                                        return;
                                                    }
                                                }
                                                setActiveStep(index);
                                            }
                                        }}>
                                            {label}
                                        </StepButton>
                                    </Step>
                                ))}
                            </Stepper>

                            <div className="mt-4">
                                {renderStepContent(activeStep)}
                            </div>

                            <Row className="formBtnsDiv mt-4">
                                <Col md={12}>
                                    <Button variant="secondary" disabled={activeStep === 0} onClick={handleBack} className="mr-2">Back</Button>
                                    {activeStep === steps.length - 1 ? (
                                        <Button variant="primary" onClick={saveForm}>Submit</Button>
                                    ) : (
                                        <Button variant="primary" onClick={handleNext}>Next</Button>
                                    )}
                                    <Button variant="outline-secondary" onClick={() => history.push('/eventVendorList')} className="ml-2">Cancel</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <ToastContainer />
        </Container>
    );
};

export default EventVendorForm;
